export type IListTabProps<T = any> = {
  key: T;
  name: string;
  disabled?: boolean;
  isComingSoon?: boolean;
};
export enum FILTER_KEY {
  SEARCH = 'search',
  TAB_INDEX = 'tab_index',
  CAMPAIGN_TYPE = 'campaign_type',
  SORT = 'sort',
  STATUS = 'status',
  IS_SELECTED_TAB_GP = 'isSelectedTabGP',
}
